import React from 'react';

function ClientsBenefitsIcon3() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="32"
      fill="none"
      viewBox="0 0 36 32"
    >
      <g clipPath="url(#clip0_257_931)">
        <path
          fill="#1B1F2C"
          d="M35.825 25.167l-8.737-20C26.778 4.456 26.1 4 25.355 4h-6.1l.154 1.447a.5.5 0 01-.497.553h-1.823a.5.5 0 01-.497-.553L16.744 4h-6.1c-.745 0-1.422.456-1.733 1.167l-8.737 20C-.403 26.49.52 28 1.91 28h12.303l.644-6.105A1 1 0 0115.85 21h4.3a1 1 0 01.995.895L21.789 28h12.303c1.389 0 2.311-1.509 1.733-2.833zm-19.55-16.72A.5.5 0 0116.773 8h2.455a.5.5 0 01.498.447l.287 2.724a.75.75 0 01-.745.829h-2.534a.75.75 0 01-.746-.829l.287-2.723zM19.728 19h-3.456a1 1 0 01-.994-1.105l.317-3a1 1 0 01.994-.895h2.822a1 1 0 01.994.895l.317 3A1 1 0 0119.728 19z"
        />
      </g>
      <defs>
        <clipPath id="clip0_257_931">
          <path fill="#fff" d="M0 0H36V32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ClientsBenefitsIcon3;
